import React from 'react';
import { useDemo } from '../context/DemoContext';

/**
 * Compact "DEMO" badge shown in the sidebar/header when demo mode is active.
 */
export function DemoBadge({ className = '' }) {
  const { demoMode } = useDemo();
  if (!demoMode) return null;

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider bg-[var(--msml-warning-bg)] text-[var(--msml-warning)] border border-[var(--msml-warning)]/20 ${className}`}
      data-testid="demo-badge"
    >
      Demo
    </span>
  );
}
